import UpdateOrganizationContent from "../../content/organization/updateOrganization";
import { Layout } from "../../layout/page";

export function UpdatedOrganization() {
  return (
    <Layout>
      <UpdateOrganizationContent />
    </Layout>
  );
}
